/* eslint-disable max-statements */
import React from 'react';
import ReactDOM from 'react-dom';

import UxCart from '@ux/cart';
import Cart from './Cart';
import Button from '@ux/button';
import PropTypes from 'prop-types';
import config from '../utils/config';
import { Events } from '../utils/constants';
import { getMarket, getCurrency } from '../utils/helpers';
import { sortBasketItemsAndGroups } from '@upp/shared-components/lib/basket/basketHelper';
import { IntlProvider } from 'react-intl';
import services from '../utils/services';
import i18n from '../../i18n';

class HeaderCart extends React.Component {

  constructor() {
    super(...arguments);
    this.state = {
      open: false,
      loading: false,
      pending: false,
      basket: {},
      sortedBasketItems: [],
      hasRestrictedDomains: false
    };

    this.timeoutId = null;

    this.open = this.open.bind(this);
    this.openForPending = this.openForPending.bind(this);
    this.close = this.close.bind(this);
    this.toggle = this.toggle.bind(this);
    this.continue = this.continue.bind(this);
    this.getBasket = this.getBasket.bind(this);
    this.setTimer = this.setTimer.bind(this);
    this.cancelTimer = this.cancelTimer.bind(this);
    this.setupTimers = this.setupTimers.bind(this);
    this.getRestrictedDomains = this.getRestrictedDomains.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);

    this.container = document.createElement('div');
    document.body.appendChild(this.container);

    config.init();
  }

  componentDidMount() {
    this.getBasket();
    this.setupTimers();
    document.addEventListener(Events.ADD_ITEM, this.open);
    document.addEventListener(Events.ADD_PENDING, this.openForPending);
    document.addEventListener(Events.OPEN, this.open);
    document.addEventListener(Events.CLOSE, this.close);

    // to close when clicking away from cart
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    this.container.remove();
    document.removeEventListener(Events.ADD_ITEM, this.open);
    document.removeEventListener(Events.ADD_PENDING, this.openForPending);
    document.removeEventListener(Events.OPEN, this.open);
    document.removeEventListener(Events.CLOSE, this.close);

    // cleanup for closing when clicking away from cart
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  getBasket() {
    this.cancelTimer();
    this.setState({ loading: true });
    this.getRestrictedDomains();
    services.basket.get()
      .then(basket => {
        this.setTimer();
        const sortedBasket = sortBasketItemsAndGroups(basket, true);
        this.setState({
          basket,
          sortedBasketItems: sortedBasket.basketItems,
          loading: false,
          pending: false
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  getRestrictedDomains() {
    if (this.props.checkRestrictedDomains) {
      services.restrictedDomains()
        .then(restrictedDomains => {
          const hasRestrictedDomains = restrictedDomains && restrictedDomains.domains && restrictedDomains.domains.length > 0;
          this.setState({ hasRestrictedDomains });
        });
    }
  }

  continue() {
    window.location = this.props.checkout;
  }

  cancelTimer() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  setTimer() {
    this.cancelTimer();
    if (this.timeoutId === null && this.state.open && !this.state.pending) {
      this.timeoutId = setTimeout(() => {
        this.close();
        this.timeoutId = null;
      }, 10000);
    }
  }

  setupTimers() {
    const hc = document.getElementsByClassName('hc-header-cart')[1];
    if (hc) {
      hc.addEventListener('mouseenter', this.cancelTimer);
      hc.addEventListener('mousemove', this.cancelTimer);
      hc.addEventListener('mouseleave', this.setTimer);
    }
  }

  openForPending() {
    // dont time this, wait for refresh event
    this.setState({ open: true, pending: true }, this.cancelTimer());
  }

  open() {
    if (!this.state.open) {
      this.setState({ open: true }, this.setTimer());
    }
  }

  close() {
    if (this.state.open) {
      this.setState({ open: false }, this.cancelTimer());
    }
  }

  toggle() {
    this.state.open ? this.close() : this.open();
  }

  handleClickOutside(event) {
    if (this.contentWrapper && !this.contentWrapper.contains(event.target)) {
      this.close();
    }
  }

  render() {
    const { basket, sortedBasketItems, loading, hasRestrictedDomains } = this.state;
    const market = getMarket();
    const currency = getCurrency();
    const messages = i18n(market);

    const hcClasses = this.state.open ? 'hc-header-cart is-open' : 'hc-header-cart';
    const flyoutClasses = this.state.open ? 'hc-flyout open' : 'hc-flyout';

    const flyout = (
      <div className={ hcClasses } ref={ r => { this.contentWrapper = r; } }>
        <div className={ flyoutClasses } >
          <Cart
            basket={ basket }
            sortedBasketItems={ sortedBasketItems }
            hasRestrictedDomains={ hasRestrictedDomains }
            loading={ loading }
            onChange={ this.getBasket }
            onClose={ this.close }
            onContinue={ this.continue }
            currency={ currency }
            market={ market }
            language={ messages }
          />
        </div>
      </div>
    );

    return (
      <div className={ hcClasses }>
        <IntlProvider locale={ market } key={ market } messages={ messages }>
          <React.Fragment>
            <Button className='hc-flyout-btn' data-eid='gce.header_cart.sales_header.icon.click' design='defaultLight'
              onClick={ this.toggle }>
              <div className='hc-cart-icon'>
                <UxCart { ...this.props } messages={ messages } items={ sortedBasketItems && sortedBasketItems.length } iconOnly showEmpty />
              </div>
            </Button>
            {ReactDOM.createPortal(flyout, this.container)}
          </React.Fragment>
        </IntlProvider>
      </div>
    );
  }
}

HeaderCart.propTypes = {
  // preserving existing prop names for compatibility
  checkout: PropTypes.string.isRequired,
  checkRestrictedDomains: PropTypes.bool,
  items: PropTypes.number
};

export default HeaderCart;
